/* eslint-disable camelcase */
import { privateFetcher } from 'services';
import ENDPOINTS from '../../../constants/endpoints.constants';
import APIError from '../../../exceptions/APIError';

interface EncryptedReturnDTO {
  return_pk: string;
}

interface FetchReturnUrlParams {
  shipment_pk: number;
  order_id: string;
}

export const fetchReturnTicket = async (
  orgId: number,
  params: FetchReturnUrlParams,
): Promise<{ data: EncryptedReturnDTO }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/return-tickets/${orgId}/url-params/`;
    const { data } = await privateFetcher.get(url, { params });

    return data;
  } catch (error) {
    throw new APIError(error.message, error);
  }
};
